module.exports = __webpack_public_path__ + "assets/img/driver-btn-9fdbcd09.png";